import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { Observable } from "rxjs";
import { Store } from "@ngrx/store";
import { appErrorSelector } from "../../_store/errors/error.selectors";
import { AppState } from "../../_store/app.state";

@Injectable({
	providedIn: "root"
})
export class AppErrorGuard implements CanActivate {
	constructor(private store: Store<AppState>, private router: Router) {}
	canActivate(): Observable<boolean> | Promise<boolean> | boolean {
		return this.checkAppErrorExists();
	}

	private checkAppErrorExists(): Observable<boolean> {
		return new Observable(observer => {
			this.store.select(appErrorSelector).subscribe(error => {
				if (error) {
					observer.next(true);
					observer.complete();
				} else {
					observer.next(false);
					observer.complete();
					window.location.href = "/";
				}
			});
		});
	}
}
